
/* eslint-disable */
import commonsMutations from '../commons/mutations'
export default {
    ...commonsMutations,
}